<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">{{ titulo_caderno }}</h1>
          <br>
          <b-row v-for="(proposta, index) in propostas" :key="proposta.id" style="margin-top: 10px">
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <b-form-group v-if="proposta.disabled">
                    <div v-html="proposta.texto" class="text-proposta"></div>
                  </b-form-group>
                  <b-form-group v-if="!proposta.disabled">
                    <vue-editor :disabled="disable_buttons" v-model="proposta.texto" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="valida_periodo && user_id == proposta.user_id">
                <b-col cols="8"></b-col>
                <b-col cols="4">
                  <b-button variant="info" v-if="proposta.disabled" :disabled="disable_buttons"
                    v-on:click="alteraVisivel(index)" style="float: right; margin-left: 10px;">
                    Editar Proposta
                  </b-button>
                  <b-button v-else variant="success" :disabled="disable_buttons" v-on:click="confirmarEditar(proposta)"
                    style="float: right; margin-left: 10px;">
                    Enviar Proposta
                  </b-button>
                  <b-button variant="danger" :disabled="disable_buttons" v-on:click="removerProposta(proposta.id)"
                    style="float: right; margin-left: 10px;">
                    Excluir Proposta
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr>
          <b-row v-if="valida_periodo">
            <b-col cols="12">
              <b-form-group>
                <vue-editor :disabled="disable_buttons" v-model="form.texto" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="valida_periodo">
            <b-col cols="10"></b-col>
            <b-col cols="2">
              <b-button variant="success" :disabled="disable_buttons" v-on:click="confirmar()">
                Enviar Proposta
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="voltar()">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>
<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'
import { VueEditor } from "vue2-editor";
import moment from 'moment'

Vue.component('multiselect', Multiselect)

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect,
    VueEditor
  },
  mixins: [validationMixin],
  validations: {
    //
  },
  created() {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }

    let usuario = SessionStorage.get('usuario')

    this.loadCadernoProposta(this.$route.params.id)
    this.loadProposta(this.$route.params.id)
  },
  data() {
    return {
      loading: false,
      user_id: SessionStorage.get('usuario'),
      propostas: [],
      form: {
        texto: null,
        caderno_proposta_id: this.$route.params.id
      },
      titulo_caderno: '',
      valida_periodo: true,
      data_contribuicao_inicio: null,
      data_contribuicao_fim: null,
      titulo_toast: 'Alerta!',
      disable_buttons: false,
    }
  },
  computed: {
    //
  },
  watch: {
    //
  },
  methods: {
    validaPerfil() {
      let perfil = this.$store.state.perfil.perfil
      if (perfil.is_admin_conferencia || perfil.is_admin_local) {
        return true
      }
      return false
    },
    loadProposta(id) {
      Vue.http.get('api/propostaDelegacao/' + id).then(response => {
        let data = response.body.data[0]
        this.propostas = []
        console.log(this.user_id)

        data.forEach(proposta => {
          this.propostas.push({
            id: proposta.id,
            texto: proposta.texto,
            caderno_proposta_id: proposta.caderno_proposta_id,
            user_id: proposta.user_id,
            disabled: true,
          })
        })
      })
    },
    loadCadernoProposta(id) {
      Vue.http.get('api/proposta/' + id).then(response => {
        let data = response.body.data
        this.titulo_caderno = data.titulo
        this.data_contribuicao_inicio = data.data_contribuicao_inicio
        this.data_contribuicao_fim = data.data_contribuicao_fim
        let data_hora_atual = moment().format('YYYY-MM-DD HH:mm:ss')

        if (this.data_contribuicao_inicio <= data_hora_atual && this.data_contribuicao_fim >= data_hora_atual) {
          this.valida_periodo = true
        } else {
          this.valida_periodo = false
        }
      })
    },
    removerProposta(id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja remover a proposta?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {

          this.disable_buttons = true
          Vue.http.delete('api/proposta/sugerida/' + id, {}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.loadProposta(this.$route.params.id)
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.disable_buttons = false
          }).catch(e => {
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    confirmar() {
      if (!this.form.texto) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Campo proposta e obrigatorio', 'Alerta', 5000)
        return false
      }

      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.adicionarProposta()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    adicionarProposta() {
      let data = {
        id: null,
        texto: this.form.texto,
        caderno_proposta_id: this.form.caderno_proposta_id
      }

      this.disable_buttons = true
      Vue.http.post('api/propostaDelegacao', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.form.texto = null
          this.loadProposta(this.$route.params.id)
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.disable_buttons = false
      }).catch(e => {
        this.disable_buttons = false
        if (e.data.errors.propostas[0]) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(e.data.errors.propostas[0], 'Alerta', 5000)
        }
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmarEditar(proposta) {
      if (!proposta.texto) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Campo proposta e obrigatorio', 'Alerta', 5000)
        return false
      }

      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.editarProposta(proposta)
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    editarProposta(proposta) {
      let data = {
        texto: proposta.texto,
        caderno_proposta_id: proposta.caderno_proposta_id
      }

      this.disable_buttons = true
      Vue.http.put('api/propostaDelegacao/' + proposta.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.loadProposta(this.$route.params.id)
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.disable_buttons = false
      }).catch(e => {
        this.disable_buttons = false
        if (e.data.errors.propostas[0]) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(e.data.errors.propostas[0], 'Alerta', 5000)
        }
        console.log('Servidor está fora! ' + e)
      })
    },
    alteraVisivel(index) {
      this.propostas[index].disabled = false
    },
    navigate(route) {
      this.$router.push(route)
    },
    voltar() {
      let voltar = true

      if (this.form.texto) {
        voltar = false
      }

      if (!voltar) {
        this.$bvModal.msgBoxConfirm('Tem certeza que deseja voltar? As informações que tenha inserido ou alterado serão perdidas.', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) {
            this.$router.push('/propostas/delegacao')
          }
        })
      } else {
        this.$router.push('/propostas/delegacao')
      }
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.text-proposta {
  background-color: #e4e7ea;
  /* height: 10rem; */
  padding: 0.5rem;
  min-width: 100px;
  max-width: 100%;
  min-height: 100px;
  max-height: 100%;
  /* overflow-y: scroll; */
}
</style>


// WEBPACK FOOTER //
// src/pages/site/interna/propostaDelegacao/PropostaDelegacaoForm.vue